import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/ui/Layout";
import Header from "../components/ui/Header";

import Section from "../components/ui/Section";
import ArticleCard from "../components/ui/ArticleCard";
import Container from "../components/ui/Container";
import Seo from "../components/ui/Seo";
const LoanIndex = ({ data }) => {
  return (
    <Layout>
      <Seo
        title="Different types of Home loans in New Zealand"
        description="We have a variety of loans available for you. Read more here"
      />
      <Header 
       title="Loans"
       subTitle="We have a variety of loans available to suit your needs"
      />
      <Section variant="tinted">
        <Container>
          {data.allDatoCmsLoan.edges.map(({ node }) => {
            const image = node.headerImage || {};
            return (
              <ArticleCard
                slug={`/loans/${node.slug}`}
                title={node.title}
                subTitle={node.subtitle}
                image={image}
              />
            );
          })}
        </Container>
      </Section>
    </Layout>
  );
};

export default LoanIndex;

export const query = graphql`
  query LoanIndexQuery {
    allDatoCmsLoan(sort: { fields: position, order: ASC }) {
      edges {
        node {
          title
          slug
          subtitle
          headerImage {
            fluid(
              maxWidth: 600
              maxHeight: 400
              imgixParams: { fm: "jpg", auto: "compress" }
            ) {
              ...GatsbyDatoCmsFluid
            }
          }
        }
      }
    }
  }
`;
